import { Entity, IEntity, StandardEntity } from '@infodata-group/inf-commons';
import { Employee } from './employee';
import { AbsenceType } from './absence-type';
import { DateUtils } from '../tool/date-utils';

export class Report implements IEntity, Entity {
  public id: string;
  public key: string;
  public typeLabel: string;
  public postponement: string; // report
  public legal: string; // congé légaux
  public additional: string; // fériés compensés
  public hoursAsked: string; // Posé
  public pay: string; // restant
  public request: string; // demande
  public anterior: string;
  public posterior: string;
  public user: StandardEntity;

  public icon: string;
  public color: string;

  public lock = false;

  public static fromEmployee(employee: Employee, category: AbsenceType) {
    const report = new Report(
      category.id,
      category.label,
      null,
      null,
      null,
      null,
      null,
      null,
    );
    report.user = employee;
    return report;
  }

  constructor(
    categoryCode: string,
    typeLabel: string,
    postponement: string,
    legal: string,
    additional: string,
    hoursAsked: string,
    pay: string,
    request: string,
  ) {
    this.id = categoryCode;
    this.typeLabel = typeLabel;
    this.postponement = postponement;
    this.legal = legal;
    this.additional = additional;
    this.hoursAsked = hoursAsked;
    this.pay = pay;
    // if (!this.pay || this.pay.indexOf(':') < 0) {
    //   this.pay = '00:00';
    // }
    this.request = request;
  }

  getId(): string {
    return '';
  }

  getLabel(): string {
    return '';
  }

  serialize(): any {
    return {
      id: this.key,
      category: this.id,
      user: this.user.id,
      legal: DateUtils.convertTimeToMinutes(this.legal),
      year: new Date().getFullYear(),
      additional: DateUtils.convertTimeToMinutes(this.additional),
      postponement: DateUtils.convertTimeToMinutes(this.postponement),
    };
  }

  update(data: any) {
    this.postponement = data.postponement;
    this.legal = data.legal;
    this.additional = data.additional;
  }

  compare(comparant: any, byLabel?: boolean): number {
    return 0;
  }

  convert(item: any): any {}

  setId(id: any): any {}
}
